export const getFormattedDouble = (d) => Number(
  Number.parseFloat(Math.round(d * 100) / 100),
)?.toLocaleString('pt-BR', {
  minimumFractionDigits: 2, maximumFractionDigits: 2,
});

export const getOnlyNumbers = (value) => value.replace(/\D/g, '');

export const formatTelephone = (rawValue) => {
  const value = rawValue.replace(/\D/g, ''); // Only numbers
  if (value.length === 0) {
    return '';
  }
  if (value.length === 1 || value.length === 2) {
    return `(${value.slice(0, 2)}`;
  }
  if (value.length >= 3 && value.length <= 6) {
    return `(${value.slice(0, 2)}) ${value.slice(2, 6)}`;
  }
  if (value.length <= 10) {
    return `(${value.slice(0, 2)}) ${value.slice(2, 6)}-${value.slice(6, 10)}`;
  }
  return `(${value.slice(0, 2)}) ${value.slice(2, 7)}-${value.slice(7, 11)}`;
};

export const toCurrency = (value) => value ? `R$ ${getFormattedDouble(value)}` : '---';
